import { MENU_CLOSE_REASON_BACKDROP } from "../types/constants";

/** Wraps a close handler so a Menu ignores clicks outside it. */
export const ignoreBackdropClose = (close) => (_event, reason) => {
  if (reason !== MENU_CLOSE_REASON_BACKDROP) close();
};

/** Returns the literal to save from the entry fields, or undefined if none. */
export const pendingLiteralValue = ({
  showString,
  showNumber,
  showDate,
  stringValue,
  numberValue,
  dateValue,
}) => {
  if (showString && ((!showNumber && !showDate) || stringValue !== ""))
    return stringValue;
  if (showNumber && numberValue !== null) return numberValue;
  if (showDate && dateValue) return dateValue;
  return undefined;
};
